import { UPLOAD_KEYS, UploadKey } from './NewPack.constants';

export const checkIsUploadField = (fieldKey: string): fieldKey is UploadKey => {
    return UPLOAD_KEYS.includes(fieldKey as UploadKey);
};
